import { graphql } from '@apollo/react-hoc';
import compose from 'lodash/flowRight';
import gql from 'graphql-tag';
import addDays from 'date-fns/addDays';
import max from 'date-fns/max';

import toISODateString from '../../utils/toISODateString';
import SchedulingCalendar from './SchedulingCalendar';

export const OFFICE_CALENDAR_NEXT_OPENING_QUERY = gql`
  query OfficeCalendarNextOpeningQuery($officeId: ID!, $reasonForVisitId: ID!, $after: String!) {
    nextOpening(officeId: $officeId, reasonForVisitId: $reasonForVisitId, after: $after) {
      id
      time
      provider {
        id
      }
    }
  }
`;

const addNextOpeningData = graphql(OFFICE_CALENDAR_NEXT_OPENING_QUERY, {
  alias: 'withNextOpeningData',
  name: 'nextOpeningData',
  options({ office, reasonForVisit, minDate }) {
    return {
      variables: {
        officeId: office.id,
        reasonForVisitId: reasonForVisit.id,
        after: toISODateString(minDate),
      },
      ssr: false,
    };
  },
});

export const OFFICE_CALENDAR_OPENINGS_QUERY = gql`
  query OfficeCalendarOpeningsQuery(
    $officeId: ID!
    $reasonForVisitId: ID!
    $after: String!
    $before: String!
  ) {
    openings(
      officeId: $officeId
      reasonForVisitId: $reasonForVisitId
      after: $after
      before: $before
    ) {
      pageInfo {
        nextAvailableDate
      }
      nodes {
        id
        time
        provider {
          id
        }
      }
    }
  }
`;

const addOpeningsData = graphql(OFFICE_CALENDAR_OPENINGS_QUERY, {
  alias: 'withOpeningsData',
  name: 'openingsData',
  options({ office, reasonForVisit, selectedDate, minDate }) {
    const after = max([selectedDate, minDate]);
    return {
      variables: {
        officeId: office.id,
        reasonForVisitId: reasonForVisit.id,
        after: toISODateString(after),
        // Querying 8 days of data due to openings being clipped for (HST, UTC-10) timezone because of the big time difference.
        before: toISODateString(addDays(after, 8)),
      },
      ssr: false,
    };
  },
});

export default compose(addNextOpeningData, addOpeningsData)(SchedulingCalendar);
